import {
  Button,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import "../../../assets/css/steps.css";

const Step_8_Delegation = ({}) => {
  return (
    <Grid container>
      <Grid item xs={12} className="container-steps">
        <Typography className="title-steps">
          Grazie! La tua delega è stata registrata
        </Typography>
        <Typography className="text-steps" style={{ marginTop: "10px" }}>
          <span style={{ fontWeight: "bold" }}>
            {" "}
            Hai concluso correttamente il processo
          </span>{" "}
          di delega e sarai rappresentato in assemblea secondo le tue scelte di
          voto. In caso di necessità, verrai contattato dal nostro team. Puoi
          chiudere questa schermata. Se hai domande o dubbi scrivici a{" "}
          <a className="link" href="mailto:sollecitazionemps@lexia.it">
            sollecitazionemps@lexia.it
          </a>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Step_8_Delegation;
